import type { PromotionalCardTitle } from '@eneco/sparky';

const MAX_TITLE_LINES = 4;

/** Maps a hero title to a PromotionalCard title (2–4 non-empty lines). */
export const toPromotionalCardTitle = (title?: string | null): PromotionalCardTitle | undefined => {
  const lines = (title ?? '')
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(Boolean)
    .slice(0, MAX_TITLE_LINES);

  if (lines.length === 1) {
    const words = lines[0].split(/\s+/).filter(Boolean);
    if (words.length < 2) {
      return undefined;
    }

    const mid = Math.ceil(words.length / 2);
    return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
  }

  const [first, second, third, fourth] = lines;

  if (first && second && third && fourth) {
    return [first, second, third, fourth];
  }

  if (first && second && third) {
    return [first, second, third];
  }

  if (first && second) {
    return [first, second];
  }

  return undefined;
};
